"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profilePromise = void 0;
async function profilePromise({ method, uri, promise, logger, shouldLog, overridePerformance = typeof performance !== 'undefined' && performance, overrideProcess = process, }) {
    const start = shouldLog && logger && calculateStart(overridePerformance, overrideProcess);
    if (shouldLog && logger) {
        let error;
        let response;
        try {
            response = await promise;
        }
        catch (e) {
            error = e;
        }
        const elapsedMS = elapsedMilliseconds(start, overridePerformance, overrideProcess);
        let retVal = formatTime(elapsedMS) + ' ' + calculateLabel(method, uri);
        if ((error === null || error === void 0 ? void 0 : error.code) || (error === null || error === void 0 ? void 0 : error.message)) {
            retVal += calculateError(error);
        }
        logger.silly(retVal);
        if (error) {
            error['method'] = method;
            error['uri'] = uri;
            throw error;
        }
        return response;
    }
    else {
        return await promise;
    }
}
exports.profilePromise = profilePromise;
function calculateStart(overridePerformance, overrideProcess) {
    if (typeof overridePerformance !== 'undefined' && (overridePerformance === null || overridePerformance === void 0 ? void 0 : overridePerformance.now)) {
        return overridePerformance.now();
    }
    if (typeof overrideProcess !== 'undefined' && (overrideProcess === null || overrideProcess === void 0 ? void 0 : overrideProcess.hrtime)) {
        return overrideProcess.hrtime();
    }
    return Date.now();
}
function elapsedMilliseconds(start, overridePerformance, overrideProcess) {
    if (typeof start === 'number' && typeof overridePerformance !== 'undefined' && (overridePerformance === null || overridePerformance === void 0 ? void 0 : overridePerformance.now)) {
        return overridePerformance.now() - start;
    }
    if (typeof start !== 'number' && typeof overrideProcess !== 'undefined' && (overrideProcess === null || overrideProcess === void 0 ? void 0 : overrideProcess.hrtime)) {
        const hrTime = overrideProcess.hrtime(start);
        const oneThousand = 1e3;
        const oneMillion = 1e6;
        return hrTime[0] * oneThousand + hrTime[1] / oneMillion;
    }
    return Date.now() - (typeof start !== 'number' ? start[0] : start);
}
function formatTime(elapsedMS) {
    const fractionalDigits = 2;
    const timeColumnWidth = 9;
    let retVal = elapsedMS.toFixed(fractionalDigits);
    while (retVal.length < timeColumnWidth) {
        retVal = ' ' + retVal;
    }
    return retVal + 'ms';
}
function calculateLabel(method, uri) {
    return `${color("\u001B[35m", method)} ${color("\u001B[36m", uri)}${color("\u001B[0m")}`;
}
function calculateError(error) {
    return ` ${color("\u001B[31m", '!! Hit Error:')}${color("\u001B[0m")} ${[error.code, error.message].filter(Boolean).join(' / ')}`;
}
function color(as, text) {
    if (process.env.COLORS === '0' || process.env.COLORS === 'false') {
        return text || '';
    }
    return `${as}${text || ''}`;
}
//# sourceMappingURL=profile.js.map